import { useMemo } from "react";
import { useOptions } from "../context/optionContext";
import { COMPANY_EMAIL, COMPANY_NAME, COMPANY_ADDRESS, COMPANY_PHONE, COMPANY_SOCIAL1, COMPANY_SOCIAL2, COMPANY_SOCIAL3, COMPANY_SOCIAL4 } from "../config";

const useCompanyInfo = () => {
	const optionsContext = useOptions();
	const optionKeys = optionsContext?.optionKeys;
	const optionsLoading = optionsContext?.optionsLoading ?? false;

	return useMemo(() => {
		const companyName = optionKeys?.companyName || COMPANY_NAME || "";
		const companyEmail = optionKeys?.companyEmail || COMPANY_EMAIL || "";
		const companyWebsite = optionKeys?.companyWebsite || "";
		const companyAddress = optionKeys?.companyAddress || COMPANY_ADDRESS || "";
		const companyPhone = optionKeys?.companyPhone || COMPANY_PHONE || "";
		const companySocial1 = optionKeys?.companySocial1 || COMPANY_SOCIAL1 || "";
		const companySocial2 = optionKeys?.companySocial2 || COMPANY_SOCIAL2 || "";
		const companySocial3 = optionKeys?.companySocial3 || COMPANY_SOCIAL3 || "";
		const companySocial4 = optionKeys?.companySocial4 || COMPANY_SOCIAL4 || "";
		return {
			companyName,
			companyEmail,
			companyWebsite,
			companyAddress,
			companyPhone,
			companySocial1,
			companySocial2,
			companySocial3,
			companySocial4,
			isReady: !optionsLoading,
		};
	}, [optionKeys, optionsLoading]);
};

export default useCompanyInfo;
